import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from '../../utils/toast'
import { EmployeeForm } from '../../components/EmployeeForm/EmployeeForm'
import { MemberFormPageLayout } from '../../components/EmployeeForm/MemberFormPageLayout'
import { useCreateUserMutation } from '../../redux/user.endpoints'
import { CreateUserDto } from '../../types/User'
import { BackendError } from '../../types/Errors'
import { useMemberFormData } from '../../hooks/useMemberFormData'

interface Props {
  companyId: number
}

const AddEmployee = ({ companyId }: Props) => {
  const navigate = useNavigate()
  const mainRef = useRef<HTMLElement>(null)
  const [createUser, createUserResult] = useCreateUserMutation()
  const { tribes, teams, technologyList, experienceLevel, isReady } =
    useMemberFormData(companyId)

  useEffect(() => {
    if (createUserResult && createUserResult.isError) {
      const createUserError = createUserResult.error as BackendError
      if (createUserError.data.error) {
        toast.error(createUserError.data.error, {
          toastId: 'create-user-error',
        })
      } else {
        toast.error(`An error occurred when creating member.`, {
          toastId: 'create-user-error',
        })
      }
    } else if (createUserResult && createUserResult.isSuccess) {
      toast.success(`Member created successfully!`, {
        toastId: 'create-user-success',
      })
      navigate('/members')
    }
  }, [createUserResult])

  const handleCreateUser = async (args: CreateUserDto) => {
    const result = await createUser(args)
    if (!('error' in result)) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      mainRef.current?.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }

  return (
    <MemberFormPageLayout
      ref={mainRef}
      title="Add New Member"
      isReady={isReady}
    >
      <EmployeeForm
        handleCreateSubmit={handleCreateUser}
        displayErrorBanner={createUserResult.isError}
        loading={createUserResult.isLoading}
        companyId={companyId}
        tribes={tribes}
        teams={teams}
        technologyList={technologyList}
        experienceLevel={experienceLevel}
        selectedTechStackListByUser={[]}
      />
    </MemberFormPageLayout>
  )
}

export default AddEmployee
